<partner-finder
  [(selected)]="value"
  [disabled]="disabled"
  [searchParams]="searchParams"
  [services]="relatedServices"
></partner-finder>
